import Quill from 'quill';

const AlignStyle = Quill.import('attributors/style/align');

export default AlignStyle;
